import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import { SupportHeaderTabs } from "./SupportHeaderTabs"

import * as s from "./SupportHeader.module.scss"

export const SupportHeader = ({ title }) => {
  const { wpPage } = useStaticQuery(graphql`
    query SupportHeaderQuery {
      wpPage: wpNodeWithTemplate(template: { templateName: { eq: "Home" } }) {
        ... on WpPage {
          acfHome {
            headerImage {
              sourceUrl
            }
          }
        }
      }
    }
  `)

  return (
    <div
      className={`${s.Wrapper}`}
      style={{
        backgroundImage: `URL(${wpPage.acfHome.headerImage.sourceUrl})`,
      }}
    >
      <div className={s.Wrapper__overlay}></div>
      <div className={s.Inner}>{title && <h1>{title}</h1>}</div>

      <SupportHeaderTabs />
    </div>
  )
}
